module.exports = __webpack_public_path__ + "static/media/display-tray.263228c6.ai";